var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    zoomAndPan: "magnify",
    viewBox: "0 0 150 149.999998",
    height: 200,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1a4789",
    d: "M 150 127.191406 C 150 139.777344 139.796875 149.980469 127.207031 149.980469 L 22.796875 149.980469 C 10.210938 149.980469 0.00390625 139.777344 0.00390625 127.191406 L 0.00390625 22.78125 C 0.00390625 10.191406 10.210938 -0.0117188 22.796875 -0.0117188 L 127.207031 -0.0117188 C 139.796875 -0.0117188 150 10.191406 150 22.78125 Z M 150 127.191406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 99.390625 86.640625 L 101.816406 67.832031 L 83.195312 67.832031 L 83.195312 55.824219 C 83.195312 50.378906 84.714844 46.667969 92.519531 46.667969 L 102.472656 46.664062 L 102.472656 29.84375 C 100.753906 29.613281 94.847656 29.101562 87.960938 29.101562 C 73.601562 29.101562 63.777344 37.867188 63.777344 53.964844 L 63.777344 67.832031 L 47.535156 67.832031 L 47.535156 86.640625 L 63.777344 86.640625 L 63.777344 134.894531 L 83.195312 134.894531 L 83.195312 86.640625 Z M 99.390625 86.640625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.9c43323e4a9e3fe5a56b587e3de2b56a.svg";
export { ForwardRef as ReactComponent };